import React, { HTMLAttributes } from "react"
import styled from "styled-components"
import cn from "clsx"

const HeadingTypography = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;

  &.variant-h1 {
    font-size: 48px;
    line-height: 58px;
  }

  &.variant-h2 {
    font-size: 36px;
    line-height: 44px;
  }

  &.variant-h3 {
    font-size: 32px;
    line-height: 40px;
  }

  &.variant-h4 {
    font-size: 24px;
    line-height: 30px;
  }

  &.variant-h5 {
    font-size: 18px;
    line-height: 22px;
  }

  &.variant-h6 {
    font-size: 16px;
    line-height: 20px;
  }

  &.variant-xs {
    font-size: 12px;
    line-height: 16px;
  }

  &.color-success {
    color: ${(props) => props.theme.palette.success};
  }

  &.color-informative {
    color: ${(props) => props.theme.palette.informative};
  }

  &.color-error {
    color: ${(props) => props.theme.palette.error};
  }

  &.color-primary-dark {
    color: ${(props) => props.theme.palette.primary_one};
  }

  &.color-primary_alt_medium {
    color: ${(props) => props.theme.palette.secondary_three};
  }

  &.color-primary-alt-soft {
    color: ${(props) => props.theme.palette.secondary_four};
  }

  &.color-gray-dark {
    color: ${(props) => props.theme.palette.text};
  }

  &.color-gray-medium {
    color: ${(props) => props.theme.palette.subtitle};
  }

  &.color-gray-light {
    color: ${(props) => props.theme.palette.disabled};
  }

  &.color-black {
    color: ${(props) => props.theme.palette.black};
  }

  &.color-white {
    color: ${(props) => props.theme.palette.white};
  }
`

export interface HeadingProps extends HTMLAttributes<HTMLDivElement> {
  variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "xs"
  className?: string
  color?:
    | "success"
    | "informative"
    | "error"
    | "primary-dark"
    | "primary_alt_medium"
    | "primary-alt-soft"
    | "gray-dark"
    | "gray-medium"
    | "gray-light"
    | "black"
    | "white"
  testId?: string
}

const Heading = (props: HeadingProps) => {
  const { variant, className, color = "gray-dark", testId, ...rest } = props

  return (
    <HeadingTypography
      data-testid={testId}
      className={cn(`variant-${variant}`, `color-${color}`, className)}
      {...rest}
    />
  )
}

export default Heading
